/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from '../../../store/reducers/notifications';

const checkIfNotificationIsValid = (data = {}) => {
  const url = window.location.href;
  if (data.namespace === 'SCL') {
    if (url.includes('scl')) {
      return true;
    }
  }
  if (data.namespace === 'Stakeholder') {
    if (url.includes('scp')) {
      return true;
    }
  }
  if (data.namespace === 'Publication') {
    return true;
  }
  return false;
}

export default function useNotifications({
  socket,
  ignore,
  api,
}) {
  const notifications = useSelector((state) => state.notifications);
  const dispatch = useDispatch();

  const hasStartedNotifications = useMemo(() => !!(notifications || []).find((s) => s.status === 'started'), [notifications]);

  const addNotification = (data) => {
    if (data.isProject) {
      dispatch(actions.addNotifications({ data, api }));
      return;
    }

    if (checkIfNotificationIsValid(data)) {
      if (!ignore) {
        dispatch(actions.addNotifications({ data, api }));
      }
    }
  };

  useEffect(() => {
    if (socket) {
      if (socket.hasListeners('notification')) {
        socket.removeListener('notification');
      }
      socket.on('notification', (data) => {
        if (data) {
          addNotification(data);
        }
      })
    }
  }, [socket, ignore]);

  const notificationsBellClicked = (visible) => { };

  return {
    addNotification,
    notificationsBellClicked,
    hasStartedNotifications,
  };
}
